<template>
  <ul class="nav navbar-right top-nav">
    <li v-if="isAdmin && currentTenant !== '' && currentTenant !== 'ezy'">
      <ExportImportSettings />
    </li>
    <li v-if="isAdmin">
      <TenantModifier />
    </li>
    <li>
      <span class="navbar-text">
        Tenant:
        <strong>{{ currentTenant }}</strong>
      </span>
    </li>
    <li class="dropdown">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown">
        <span class="material-symbols-outlined">account_circle</span>
        <span class="username">{{ username }}</span>
        <b class="fa fa-angle-down"></b>
      </a>
      <ul class="dropdown-menu">
        <li>
          <a href="#" @click="logout"> <i class="fa fa-fw fa-power-off"></i> Logout </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import TenantModifier from './TenantModifier'
import ExportImportSettings from './ExportImportSettings'

export default {
  components: {
    TenantModifier,
    ExportImportSettings
  },
  computed: {
    ...mapGetters([
      'username',
      'currentTenant',
      'isLoggedIn',
      'isAdmin'
    ])
  },
  methods: {
    logout() {
      this.$store.commit('logout')
    }
  }
}
</script>

<style scoped>
.form-inline {
  padding: 8px;
}
li > .btn {
  margin-top: 15px;
}
.navbar-text {
  padding: 10px;
  margin: 10px;
  color: #fff;
}

.dropdown-toggle {
    display: flex;
    align-items: center;
}

.username {
  margin: 0 5px;
}

@media (max-width: 768px) {
  .navbar-text {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue